module.exports = __webpack_public_path__ + "img/regierungskrise-thueringen.6ea2f5c3.png";